const legacyBreakpoints = {
    xxl: { value: "96em" },
    hd: { value: "120em" }
};

export const breakpoints = {
    sm: { value: "30rem" },
    md: { value: "48rem" },
    lg: { value: "70rem" },
    ...legacyBreakpoints
};
